import React from "react";
import { useAuth } from "../../../context/AuthContext";
import styles from "./Topbar.module.css";
import { FiSearch, FiBell,  FiUser } from "react-icons/fi";

import { FaQuestionCircle } from "react-icons/fa";

const Topbar = (props) => {
  const { userdata } = useAuth();
  const data = userdata;

  return (
    <header className={styles.topbar}>
      <div>
        <div className={styles.breadcrumb}>Home &gt; Dashboard</div>
        <h2>{props.heading}</h2>
      </div>

      <div className={styles.actions}>
        <div className={styles.searchBox}>
          <FiSearch />
          <input type="text" placeholder="Search..." />
        </div>
        <div className={styles.notificationOuter}>
          <FiBell className={styles.bell} />
        </div>
        {props.role === "institution" ? (
          <button className={styles.propose}>+ Propose Event</button>
        ) : (
          <div className={styles.notificationOuter}>
            <FaQuestionCircle />
          </div>
        )}

        <div className={styles.profile}>
          <div className={styles.userPic}>
          <FiUser className={styles.bell} />  
          </div>
          <div className={styles.nameBox}>
          <h4>{data?.name}</h4>
          <span>{data?.email}</span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Topbar;
